import styled from "@emotion/styled";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  padding: 83px 0;
  background-color: ${p => p.theme.colors.white};
  border-radius: ${p => p.theme.radii.normal};

  @media screen and (max-width: ${p => p.theme.screenSizes.mdMin}) {
    padding: 25px 0;
  }
`;

export const Progress = styled.p`
  margin-top: ${p => p.theme.space[5]}px;
  margin-bottom: ${p => p.theme.space[0]};

  font-size: ${p => p.theme.fontSizes.xl};
  font-weight: ${p => p.theme.fontWeight.medium};

  @media screen and (max-width: ${p => p.theme.screenSizes.mdMin}) {
    font-size: ${p => p.theme.fontSizes.l};
  }
`;

export const ImgWrapper = styled.div`
  width: 177px;
  height: 177px;

  @media screen and (max-width: ${p => p.theme.screenSizes.mdMin}) {
    width: 141px;
    height: 141px;
  }

  animation: ${p => (p.animate ? p.theme.animate : "")};

  transform-origin: center;

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
